import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";

import { toValueLabel } from "Screen/Components/Basic/util";
import { t } from "../../services/i18n/index";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  next_modal,
  accounts_auth_type,
  accounts,
  dispatch_danger,
  dispatch_post_accounts_auth,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [mail_address, set_mail_address] = useState(accounts.mail_address);
  const [password, set_password] = useState("");
  const [password_confirm, set_password_confirm] = useState("");

  const [country_code, set_country_code] = useState(accounts.country_code);
  const [phone_number, set_phone_number] = useState(accounts.phone_number);
  const [phone_number_international, set_phone_number_international] = useState(
    ""
  );
  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {accounts_auth_type === 4
              ? t("パスワードを変更")
              : accounts_auth_type === 2
              ? t("メールアドレスを変更")
              : accounts_auth_type === 3
              ? t("電話番号を変更")
              : ""}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                {accounts_auth_type === 4 ? (
                  <>
                    <TextField
                      value={password}
                      onChange={(event) => set_password(event.target.value)}
                      id="standard-basic"
                      label={t("パスワード")}
                      style={{ width: "100%" }}
                      variant="standard"
                      margin="dense"
                    />
                    <TextField
                      value={password_confirm}
                      onChange={(event) =>
                        set_password_confirm(event.target.value)
                      }
                      id="standard-basic"
                      label={t("パスワード(確認用)")}
                      style={{ width: "100%" }}
                      variant="standard"
                      margin="dense"
                    />
                  </>
                ) : accounts_auth_type === 2 ? (
                  <>
                    <TextField
                      value={mail_address}
                      onChange={(event) => set_mail_address(event.target.value)}
                      id="standard-basic"
                      label={t("メールアドレス")}
                      style={{ width: "100%" }}
                      variant="standard"
                      margin="dense"
                    />
                  </>
                ) : accounts_auth_type === 3 ? (
                  <>
                    {/* {" "}
                    <div>{country_code}</div>
                    <div>{phone_number}</div>
                    <div>{phone_number_international}</div> */}
                    <IntlTelInput
                      containerClassName="intl-tel-input"
                      inputClassName="form-control"
                      preferredCountries={["jp","us"]}
                      defaultCountry={country_code}
                      placeholder=""
                      value={phone_number}
                      onSelectFlag={(value, obj, formattedvalue, isValid) => {
                        set_country_code(obj.iso2);
                        // areaCodes:null
                        // dialCode:'93'
                        // iso2:'af'
                        // name:'Afghanistan (‫افغانستان‬‎)'
                        // priority:0

                        set_phone_number(value);
                        !isValid ||
                          set_phone_number_international(
                            formattedvalue.replace(/-/g, "").replace(/ /g, "")
                          );
                        // !isValid || set_phone_number_international(formattedvalue);
                        isValid || set_phone_number_international("");
                      }}
                      // preferredCountries={["jp"]}
                      onPhoneNumberChange={(
                        isValid,
                        value,
                        obj,
                        formattedvalue
                      ) => {
                        set_country_code(obj.iso2);
                        set_phone_number(value);
                        !isValid ||
                          set_phone_number_international(
                            formattedvalue.replace(/-/g, "").replace(/ /g, "")
                          );
                        // !isValid || set_phone_number_international(formattedvalue);
                        isValid || set_phone_number_international("");
                      }}
                      // onPhoneNumberBlur={onBlur}
                      format
                    />
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      if (accounts_auth_type === 4) {
                        if (password !== password_confirm) {
                          dispatch_danger("パスワードが異なっています。");
                          return;
                        }

                        dispatch_post_accounts_auth(
                          {
                            type: accounts_auth_type,
                            password,
                          },
                          () => {
                            close_modal();
                            next_modal();
                          }
                        );
                      }
                      if (accounts_auth_type === 2) {
                        dispatch_post_accounts_auth(
                          {
                            type: accounts_auth_type,
                            mail_address,
                          },
                          () => {
                            close_modal();
                            next_modal();
                          }
                        );
                      }
                      if (accounts_auth_type === 3) {
                        dispatch_post_accounts_auth(
                          {
                            type: accounts_auth_type,
                            phone_number: phone_number_international,
                            country_code,
                          },
                          () => {
                            close_modal();
                            next_modal();
                          }
                        );
                      }
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
